module.exports = __webpack_public_path__ + "static/img/m10.430d71c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/spark-edge/mobile/m10.png
// module id = as7x
// module chunks = 12